import React, { useEffect } from "react";
import ContactUS from "@components/contactUs";
import Map from "@components/contactUs/map";
import { GetStaticPropsContext } from "next";
import MetaTags from "@components/shared/metaTags";
import initialCall from "@helpers/initial-call";
import { useQuery } from "@tanstack/react-query";
import { GQLDomains } from "@gql/types/gql";
import { getKeyWordsForMetaTags } from "@lib/sharedUtils";
import { activePageAtom } from "@store/generalStore";
import { useSetAtom } from "jotai";
import { ICustomDomain, TranslationsObject } from "@genericTypes/sharedTypes";
import { translate } from "@helpers/translationObjectFormatter";
const ContactUs = () => {
    const { data: domainInfo } = useQuery<ICustomDomain, Error>({
        queryKey: ["domain"],
    });
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);
    const setActivePage = useSetAtom(activePageAtom);
    useEffect(() => {
        setActivePage("contact us");
    }, []);
    return (
        <>
            <MetaTags
                title={`${translate(
                    translations,
                    "several_contactUS_mainTitle",
                )} | Several.com`}
                description={translate(
                    translations,
                    "several_contactUS_meta_description",
                )}
                keyWords={
                    getKeyWordsForMetaTags(
                        domainInfo?.domain as GQLDomains,
                    ) as string
                }
            />
            <section className="max-w-7xl mx-auto px-5">
                <h1 className="hidden">Contact Us</h1>
                <ContactUS />

                <Map />
            </section>
        </>
    );
};

export const getStaticProps = async (ctx: GetStaticPropsContext) => {
    return await initialCall("ContactUs", ctx);
};
export default ContactUs;
